import {
  getContent,
  mergeContent,
  newModal,
  mergeModalState,
  validateModalState,
  closeModal,
} from "@js/helpers/state.js";
import { validateNotBlank, validateMaxLength } from "@js/helpers/validators.js";

import {
  CE_MODAL_EDIT_NAME_OPEN,
  CE_MODAL_EDIT_NAME_SAVE,
} from "@js/actions/studio/campaign_content_section/modal_edit_name.js";

let preprocess = (state) => {
  // Trim leading and trailing whitespace off the name.

  let { name } = state.modal.state;

  return mergeModalState(state, {
    name: name.trim(),
    validation_errors: null,
  });
};

let validate = (state) => {
  return state;
  let { client_content_id, name: enteredName } = state.modal.state;

  let uniq = (name) => name.toLowerCase();

  const validateNameForUniqueness = () => {
    for (let content of state.data.contents) {
      if (
        content.client_content_id !== client_content_id &&
        uniq(enteredName) === uniq(content.name)
      ) {
        return [t("phrases.react_content.name_already_in_use")];
      }
    }

    return null;
  };

  return validateModalState(state, {
    name: [
      (s) => validateNotBlank(s, "name"),
      (s) => validateMaxLength(s, "name", 100),
      (s) => validateNameForUniqueness(),
    ],
  });
};

export default (state = {}, action) => {
  switch (action.type) {
    case CE_MODAL_EDIT_NAME_OPEN: {
      let { client_content_id } = action;
      let content = getContent(state, client_content_id);

      return newModal(state, "edit_name", {
        client_content_id: client_content_id,
        name: content.name,
      });
    }

    case CE_MODAL_EDIT_NAME_SAVE: {
      let preprocessedState = preprocess(state);
      let validatedState = validate(preprocessedState);

      if (validatedState.modal.state.validation_errors) {
        return validatedState;
      }

      let { client_content_id, name } = preprocessedState.modal.state;

      return mergeContent(closeModal(state), client_content_id, {
        name: name,
      });
    }

    default:
      return state;
  }
};
